import React from "react";
import PatrinoimeHeroSection from "../components/PatrimoineSection/PatrinoimeHeroSection";
 import PatrimoineNavigationMenu from "../components/PatrimoineSection/PatrimoineNavigationMenu";

const Patrimoine = () => {
  return (
    <div>
      <PatrinoimeHeroSection />
     <PatrimoineNavigationMenu/>

    </div>
  );
};

export default Patrimoine;
